<template>
  <div>
    <div class="conTit" style="margin-top:10px">
      <span></span>
      <p>渠道维度</p>
      <!-- <p class="conTitAb">Time Gone：{{achVing}}</p> -->
    </div>
    <ul class="pro_list">
      <van-row type="flex" justify="center" class="olTit">
        <van-col span="7">
          <p>渠道</p>
        </van-col>
        <van-col span="6">
          <p>销售额 (`000)</p>
        </van-col>
        <!-- <van-col span="6">
          <p>目标(`000)</p>
        </van-col>
        <van-col span="4">
          <p>完成率</p>
        </van-col>-->
        <van-col span="4">
          <p>vs.ly</p>
        </van-col>
      </van-row>
    </ul>
    <div class="box">
      <van-row type="flex" justify="center" class="OneTie active">
        <van-col span="7">全网汇总</van-col>
        <van-col span="10">{{salesValue|NumFormat}}</van-col>
        <!-- <van-col span="6">{{targetValue|NumFormat}}</van-col>
        <van-col span="4">{{achieving==''?0.0+'%':achieving}}</van-col>-->
        <van-col span="4">{{lyValue==''?0.0+'%':lyValue}}</van-col>
      </van-row>
    </div>

    <div class="box" v-for="(item,i) in tableList" :key="i">
      <van-row type="flex" justify="center" class="OneTie active">
        <van-col span="7">{{item.totalChannel}}</van-col>
        <van-col span="10">{{item.salesValue|NumFormat}}</van-col>
        <!-- <van-col span="6">{{item.targetValue|NumFormat}}</van-col>
        <van-col span="4">{{item.achieving==''?0.0+'%':item.achieving}}</van-col>-->
        <van-col span="4">{{item.ly==''?0.0+'%':item.ly}}</van-col>
      </van-row>
      <div
        v-show="isShow"
        v-for="(item1,i1) in item.channelList"
        :key="i1"
        @click.prevent="show(i1,$event)"
      >
        <van-row type="flex" justify="center" class="OneTie">
          <div class="red"></div>
          <van-col span="7">{{item1.channelNm}}</van-col>
          <van-col span="10">{{item1.salesValue|NumFormat}}</van-col>
          <!-- <van-col span="6">{{item1.targetValue|NumFormat}}</van-col>
          <van-col span="4">{{item1.achieving==''?0.0+'%':item1.achieving}}</van-col>-->
          <van-col span="4">{{item1.ly==''?0.0+'%':item1.ly}}</van-col>
        </van-row>

        <van-row
          type="flex"
          justify="center"
          v-show="isShow2"
          v-for="(item2,i2) in item1.brandCdList"
          :key="i2"
          class="TwoTie"
        >
          <van-col span="7">{{item2.brandCd}}</van-col>
          <van-col span="10">{{item2.salesValue|NumFormat}}</van-col>
          <!-- <van-col span="6">{{item2.targetValue|NumFormat}}</van-col>
          <van-col span="4">{{item2.achieving==''?0.0+'%':item2.achieving}}</van-col>-->
          <van-col span="4">{{item2.ly==''?0.0+'%':item2.ly}}</van-col>
        </van-row>
      </div>
    </div>

    <div class="conTit" style="margin-top:10px">
      <span></span>
      <p>品牌维度</p>
      <!-- <p class="conTitAb">Time Gone：{{achVing}}</p> -->
    </div>
    <ul class="pro_list">
      <van-row type="flex" justify="center" class="olTit">
        <van-col span="8">
          <p>品牌</p>
        </van-col>
        <van-col span="6">
          <p>{{(new Date()).valueOf()>=1592323200000?'销售额 (`000)':'销售额 (`000)'}}</p>
        </van-col>
        <!-- <van-col span="6">
          <p>目标(`000)</p>
        </van-col>
        <van-col span="4">
          <p>完成率</p>
        </van-col>-->
        <van-col span="4">
          <p>vs.ly</p>
        </van-col>
      </van-row>
    </ul>
    <div class="box">
      <van-row type="flex" justify="center" class="OneTie active">
        <van-col span="7">全网汇总</van-col>
        <van-col span="10">{{salesValue|NumFormat}}</van-col>
        <!-- <van-col span="6">{{targetValue|NumFormat}}</van-col>
        <van-col span="4">{{achieving==''?0.0+'%':achieving}}</van-col>-->
        <van-col span="4">{{lyValue==''?0.0+'%':lyValue}}</van-col>
      </van-row>
    </div>
    <!-- 一级 -->
    <div class="box" v-for="(item,i) in tableList2" :key="item.category">
      <van-row type="flex" justify="center" class="OneTie active">
        <van-col span="7">{{item.category}}</van-col>
        <van-col span="10">{{item.salesValue|NumFormat}}</van-col>
        <!-- <van-col span="6">{{item.targetValue|NumFormat}}</van-col>
        <van-col span="4">{{item.achieving==''?0.0+'%':item.achieving}}</van-col>-->
        <van-col span="4">{{item.ly==''?0.0+'%':item.ly}}</van-col>
      </van-row>
      <!-- 二级 -->
      <div
        v-show="isShow"
        v-for="(item1,i1) in item.cateGoryList"
        @click.prevent="show(i1,$event)"
        :key="i1"
      >
        <van-row type="flex" justify="center" class="OneTie">
          <div class="red"></div>
          <van-col span="7">{{item1.brandCd}}</van-col>
          <van-col span="10">{{item1.salesValue|NumFormat}}</van-col>
          <!-- <van-col span="6">{{item1.targetValue|NumFormat}}</van-col>
          <van-col span="4">{{item1.achieving==''?0.0+'%':item1.achieving}}</van-col>-->
          <van-col span="4">{{item1.ly==''?0.0+'%':item1.ly}}</van-col>
        </van-row>

        <van-row
          type="flex"
          justify="center"
          v-show="isShow2"
          v-for="(item2,i2) in item1.channelNmList"
          :key="i2"
          class="TwoTie"
        >
          <van-col span="7">{{item2.channelNm}}</van-col>
          <van-col span="10">{{item2.salesValue|NumFormat}}</van-col>
          <!-- <van-col span="6">{{item2.targetValue|NumFormat}}</van-col>
          <van-col span="4">{{item2.achieving==''?0.0+'%':item2.achieving}}</van-col>-->
          <van-col span="4">{{item2.ly==''?0.0+'%':item2.ly}}</van-col>
        </van-row>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import qs from "qs";

export default {
  data() {
    return {
      tableList: [],
      tableList2: [],
      isShow: true,
      isShow2: false,
      DefTime: "",
      salesValue: 0,
      targetValue: 0,
      lyValue: 0,
      achieving: 0,
    };
  },
  methods: {
    getList(time) {
      this.$addr
        .post(
          "weekly/getTotalChannelData",
          qs.stringify({ weeklyFlag: 1, monthFrom: time, monthTo: time })
        )
        .then((res) => {
          this.tableList = res.data.data;
        })
        .catch((error) => {
          this.$toast("接受数据失败");
        });
    },
    getList2(time) {
      this.$addr
        .post(
          "weekly/getCateGoryData",
          qs.stringify({ weeklyFlag: 1, monthFrom: time, monthTo: time })
        )
        .then((res) => {
          this.tableList2 = res.data.data;
        })
        .catch((error) => {
          this.$toast("接受数据失败");
        });
    },
    show(i, e) {
      $(e.currentTarget).stop().find(".TwoTie").slideToggle(500);
    },
    getSum(time) {
      this.$addr
        .post(
          "weekly/getSalesSumData",
          qs.stringify({ weeklyFlag: 1, monthFrom: time, monthTo: time })
        )
        .then((res) => {
          this.achieving = res.data.data[0].achieving;
          this.salesValue = res.data.data[0].salesValue;
          this.targetValue = res.data.data[0].targetValue;
          this.lyValue = res.data.data[0].ly;
        });
    },
  },
  props: ["DefaulTime"],
  watch: {
    DefaulTime: {
      handler(newValue, oldValue) {
        this.DefTime = newValue;
        this.getList(newValue);
        this.getList2(newValue);
        this.getSum(newValue);
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.red {
  position: absolute;
  left: 15px;
  top: 15px;
  width: 0;
  height: 0;
  border: 4px solid;
  border-color: red transparent transparent transparent;
}
.pro_list {
  margin: 14px 0 0;
  width: 100%;
  text-align: center;
}
.pro_list .olTit {
  display: flex;
  height: 21px;
  background: #B1E0DA;
  align-items: center;
  justify-content: space-around;
}
.pro_list .olTit p {
  font-family: "PingFangSC-Medium";
  font-size: 12px;
  color: #343434;
}
.box {
  margin: 1.5px auto 0;
  padding: 0 14px;
  position: relative;
}
.OneTie {
  position: relative;
  text-align: left;
  width: 100%;
  height: 35px;
  background: #ffffff;
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.3);
  border-radius: 5px;
  line-height: 35px;
  text-align: center;
  font-family: "PingFangSC-Regular";
  font-size: 12px;
  color: #000000;
}
.active {
  width: 103%;
  margin-bottom: 4px;
  margin-left: -7px;
  background: #ffffff;
  box-shadow: 5px 5px 5px 0 rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  font-family: "PingFangSC-Semibold";
  font-size: 12px;
  color: #000000;
  font-weight: bold;
}
.TwoTie {
  /* display: none; */
  /* position: absolute; */
  margin-bottom: 2px;
  text-align: center;
  font-family: "PingFangSC-Light";
  font-size: 11px;
  color: #191919;
  width: 100%;
  height: 35px;
  border-bottom: 2px solid rgba(157, 157, 157, 0.4);
  line-height: 35px;
}

.conTit {
  margin-left: 8%;
  display: flex;
  align-items: center;
  height: 20px;
  width: 100%;
}
.conTit span {
  height: 13px;
  width: 5px;
  display: inline-block;
  background: #ba4d4c;
  border-radius: 3.5px;
  margin-right: 10px;
}
.conTit p {
  line-height: 21px;
  font-weight: bold;
  font-family: "STYuanti-SC-Bold";
  font-size: 16px;
  color: #595b66;
}
.conTitAb {
  position: absolute;
  right: 23px;
  line-height: 21px;
  font-weight: bold;
  font-family: "STYuanti-SC-Bold";
  font-size: 16px;
  color: #595b66;
}
</style>


// WEBPACK FOOTER //
// src/components/ButThr/ButThr_NowTable.vue